// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.restaurant-analytics-dashboard {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  margin: 0 0 16px;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: visible;
  color: #1a1a1a;
  font-family: "Open Sans", sans-serif;
}
.restaurant-analytics-dashboard__tabs {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  margin-bottom: 18px;
  border-radius: 18px;
  background: hsla(220, 10%, 46%, 0.08);
  width: fit-content;
  max-width: 100%;
  flex-shrink: 0;
}
.restaurant-analytics-dashboard__tab {
  border: 0;
  border-radius: 14px;
  background: transparent;
  color: hsl(220, 10%, 46%);
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.15;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.restaurant-analytics-dashboard__tab:hover {
  background: rgba(255, 255, 255, 0.72);
  color: #1a1a1a;
}
.restaurant-analytics-dashboard__tab--active {
  background: #ffffff;
  color: #17325c;
  box-shadow: 0 10px 26px rgba(23, 50, 92, 0.12);
}
.restaurant-analytics-dashboard__section {
  display: flex;
  flex-direction: column;
  align-self: stretch;
  gap: 16px;
  width: 100%;
  min-width: 0;
}
.restaurant-analytics-dashboard__kpi-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
@media (max-width: 1180px) {
  .restaurant-analytics-dashboard__kpi-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 640px) {
  .restaurant-analytics-dashboard__kpi-row {
    grid-template-columns: minmax(0, 1fr);
  }
}
.restaurant-analytics-dashboard__grid {
  display: grid;
  gap: 16px;
}
.restaurant-analytics-dashboard__grid--two {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
@media (max-width: 960px) {
  .restaurant-analytics-dashboard__grid--two {
    grid-template-columns: minmax(0, 1fr);
  }
}
.restaurant-analytics-dashboard__grid--branches {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
@media (max-width: 1180px) {
  .restaurant-analytics-dashboard__grid--branches {
    grid-template-columns: minmax(0, 1fr);
  }
}
.restaurant-analytics-dashboard__grid--menu-detail {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
@media (max-width: 1180px) {
  .restaurant-analytics-dashboard__grid--menu-detail {
    grid-template-columns: minmax(0, 1fr);
  }
}
.restaurant-analytics-dashboard__card--span-two {
  grid-column: span 2;
}
@media (max-width: 1180px) {
  .restaurant-analytics-dashboard__card--span-two {
    grid-column: span 1;
  }
}
.restaurant-analytics-dashboard__card--span-three {
  grid-column: span 3;
}
@media (max-width: 1180px) {
  .restaurant-analytics-dashboard__card--span-three {
    grid-column: span 1;
  }
}
.restaurant-analytics-dashboard__card {
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(18, 22, 33, 0.06);
  min-width: 0;
  height: 100%;
  overflow: hidden;
}
.restaurant-analytics-dashboard__card-head {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 32px;
  padding: 20px 20px 0;
}
.restaurant-analytics-dashboard__card-title-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.restaurant-analytics-dashboard__card-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #1a1a1a;
}
.restaurant-analytics-dashboard__card-title-row .definition-tooltip {
  display: inline-flex;
  align-items: center;
}
.restaurant-analytics-dashboard__card-body {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 16px 20px 20px;
}
.restaurant-analytics-dashboard__card:has(.restaurant-analytics-dashboard__card-footer) .restaurant-analytics-dashboard__card-body {
  padding-bottom: 0;
}
.restaurant-analytics-dashboard__card-footer {
  flex-shrink: 0;
}
.restaurant-analytics-dashboard__source-note {
  margin: 8px 0 24px;
  text-align: center;
  font-size: 11px;
  color: #9ca3af;
}

.restaurant-header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
}

.restaurant-filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
}
.restaurant-filter-bar .ant-select {
  min-width: 150px;
}
.restaurant-filter-bar__reset {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #ffffff;
  color: #1a1a1a;
  cursor: pointer;
  flex-shrink: 0;
  margin-top: 10px;
  transition: background 0.15s ease, opacity 0.15s ease;
}
.restaurant-filter-bar__reset:hover:not(:disabled) {
  background: #f8fafc;
}
.restaurant-filter-bar__reset:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  margin-top: 10px;
  width: 40px;
  height: 40px;
}

.restaurant-ai-summary {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.restaurant-kpi-card {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  min-height: 0;
  gap: 8px;
}
.restaurant-kpi-card::before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  top: 0;
  bottom: 0;
  width: 4px;
}
.restaurant-kpi-card .dashboard-kpi-card__title-row {
  align-items: center;
  margin-bottom: 0;
}
.restaurant-kpi-card .dashboard-kpi-card__title {
  line-height: 1.4;
}
.restaurant-kpi-card .definition-tooltip__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.restaurant-kpi-card--primary::before {
  background: #2b74e4;
}
.restaurant-kpi-card--success::before {
  background: #28a745;
}
.restaurant-kpi-card--warning::before {
  background: #ff6c00;
}
.restaurant-kpi-card--destructive::before {
  background: #e53935;
}

.restaurant-chart-toggle {
  display: flex;
  gap: 2px;
  padding: 2px;
  border-radius: 8px;
  background: #f8fafc;
}
.restaurant-chart-toggle__btn {
  border: 0;
  background: transparent;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
}
.restaurant-chart-toggle__btn--active {
  background: #ffffff;
  color: #1a1a1a;
  box-shadow: 0 1px 2px rgba(18, 22, 33, 0.06);
}

.restaurant-chart {
  width: 100%;
  flex: 1 1 auto;
}
.restaurant-chart .recharts-surface {
  direction: ltr;
}
.restaurant-chart--trend {
  height: 304px;
  min-height: 304px;
}
.restaurant-chart--donut {
  height: 260px;
  min-height: 260px;
}
.restaurant-chart--category-bars {
  height: 260px;
  min-height: 260px;
}
.restaurant-chart--horizontal-bars {
  height: auto;
}
.restaurant-chart__legend-label {
  font-size: 11px;
  color: #6b7280;
}

.restaurant-heatmap-body {
  padding: 16px 20px 20px;
}

.restaurant-heatmap {
  overflow-x: auto;
}
.restaurant-heatmap__row {
  display: grid;
  grid-template-columns: 56px repeat(8, minmax(0, 1fr));
  gap: 4px;
  min-width: 420px;
  margin-bottom: 4px;
}
.restaurant-heatmap__row-label {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  color: #6b7280;
}
.restaurant-heatmap__hour-label {
  text-align: center;
  font-size: 10px;
  color: #6b7280;
}
.restaurant-heatmap__cell {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
}
.restaurant-heatmap__legend {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  font-size: 10px;
  color: #6b7280;
}
.restaurant-heatmap__legend-bar {
  flex: 1 1;
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(to right, rgba(44, 104, 173, 0.12), #2b74e4);
}

.restaurant-table-body {
  padding: 0;
}

.restaurant-table-scroll {
  overflow-x: auto;
}

.restaurant-wide-table.dashboard-data-table {
  table-layout: fixed;
  width: 100%;
}
.restaurant-wide-table.dashboard-data-table th:first-child,
.restaurant-wide-table.dashboard-data-table td:first-child {
  width: 28%;
}

.restaurant-retention-table {
  width: 92%;
  min-width: 370px;
  border-collapse: separate;
  border-spacing: 4px;
  font-size: 11px;
  margin: 16px 20px 20px;
}
.restaurant-retention-table td {
  border-bottom: none;
}
.restaurant-retention-table th {
  text-align: start;
  padding: 4px;
  font-weight: 600;
  color: #6b7280;
}
.restaurant-retention-table__month-heading, .restaurant-retention-table__cell {
  text-align: center;
}
.restaurant-retention-table__cohort {
  font-weight: 500;
  white-space: nowrap;
}
.restaurant-retention-table__cell {
  padding: 8px 4px;
  border-radius: 4px;
  font-weight: 600;
}

.restaurant-abandoned-cart {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.restaurant-abandoned-cart__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
}

.restaurant-cart-funnel {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.restaurant-cart-funnel__stage-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 4px;
}
.restaurant-cart-funnel__stage-name {
  font-weight: 500;
  color: #1a1a1a;
}
.restaurant-cart-funnel__stage-value {
  font-weight: 700;
  color: #6b7280;
}
.restaurant-cart-funnel__track {
  height: 24px;
  width: 100%;
  border-radius: 8px;
  background: #f8fafc;
  overflow: hidden;
}
.restaurant-cart-funnel__fill {
  height: 100%;
  border-radius: 8px;
  background: #2b74e4;
  transition: width 0.2s ease;
}
.restaurant-cart-funnel__footer {
  margin: 4px 0 0;
  font-size: 11px;
  color: #6b7280;
}

.restaurant-branch-map {
  position: relative;
}
.restaurant-branch-map__canvas {
  height: 360px;
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}
.restaurant-branch-map__pin {
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 4px 14px rgba(18, 22, 33, 0.1);
  opacity: 0.85;
  cursor: pointer;
  transition: transform 0.15s ease;
  padding: 0;
}
.restaurant-branch-map__pin:hover {
  transform: scale(1.1);
}
.restaurant-branch-map__popup {
  position: absolute;
  transform: translate(-50%, -100%);
  margin-top: -16px;
  min-width: 160px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 14px rgba(18, 22, 33, 0.1);
  font-size: 12px;
  z-index: 2;
  pointer-events: none;
}
.restaurant-branch-map__popup p {
  margin: 2px 0;
  color: #6b7280;
}
.restaurant-branch-map__popup-name {
  font-weight: 700;
  color: #1a1a1a;
}
.restaurant-branch-map__popup-city {
  color: #9ca3af;
}

@media (max-width: 1024px) {
  .dashboard-section-header__actions {
    justify-content: flex-end !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/dashboards/restaurantAnalytics/components/RestaurantAnalyticsTabsDashboard.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cCkNQ;EDjNR,oCCoMY;AD1Md;AAQE;EACE,oBAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AANJ;AASE;EACE,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,uEAAA;AAPJ;AASI;EACE,qCAAA;EACA,cCoLI;AD3LV;AAWE;EACE,mBAAA;EACA,cAAA;EACA,8CAAA;AATJ;AAYE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AAVJ;AAaE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAXJ;AAaI;EALF;IAMI,gDAAA;EAVJ;AACF;AAYI;EATF;IAUI,qCAAA;EATJ;AACF;AAYE;EACE,aAAA;EACA,SAAA;AAVJ;AAYI;EACE,gDAAA;AAVN;AAYM;EAHF;IAII,qCAAA;EATN;AACF;AAYI;EACE,gDAAA;AAVN;AAYM;EAHF;IAII,qCAAA;EATN;AACF;AAYI;EACE,gDAAA;AAVN;AAYM;EAHF;IAII,qCAAA;EATN;AACF;AAaE;EACE,mBAAA;AAXJ;AAaI;EAHF;IAII,mBAAA;EAVJ;AACF;AAaE;EACE,mBAAA;AAXJ;AAaI;EAHF;IAII,mBAAA;EAVJ;AACF;AAaE;EACE,aAAA;EACA,sBAAA;EACA,mBCpHI;EDqHJ,yBAAA;EACA,kBC8EQ;ED7ER,4CAhIqB;EAiIrB,YAAA;EACA,YAAA;EAEA,gBAAA;AAZJ;AAeE;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAdJ;AAiBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cCkEM;ADjFV;AAmBE;EACE,oBAAA;EACA,mBAAA;AAjBJ;AAoBE;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;AAlBJ;AAqBE;EACE,iBAAA;AAnBJ;AAsBE;EACE,cAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cCuCY;AD5DhB;;AA0BA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;AAvBF;;AA2BA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,SAAA;AAxBF;AA0BE;EACE,gBAAA;AAxBJ;AA2BE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBCbQ;EDcR,mBClNI;EDmNJ,cCIM;EDHN,eAAA;EACA,cAAA;EACA,gBAAA;EACA,qDAAA;AAzBJ;AA2BI;EACE,mBCEQ;AD3Bd;AA4BI;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACC,WAAA;EACD,YAAA;AA1BN;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5BF;;AAgCA;EACE,kBAAA;EACA,gBAAA;EACA,kBC7CU;ED8CV,aAAA;EACA,QAAA;AA7BF;AA+BE;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;AA7BJ;AAgCE;EACE,mBAAA;EACA,gBAAA;AA9BJ;AAiCE;EACE,gBAAA;AA/BJ;AAkCE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AAhCJ;AAmCE;EACE,mBCzDS;ADwBb;AAoCE;EACE,mBCrDS;ADmBb;AAqCE;EACE,mBCvDS;ADoBb;AAsCE;EACE,mBC5DQ;ADwBZ;;AA0CA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,kBChGU;EDiGV,mBCzEY;ADkCd;AAyCE;EACE,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCtFgB;EDuFhB,eAAA;AAvCJ;AAyCI;EACE,mBClTE;EDmTF,cC5FI;ED6FJ,4CA7TmB;AAsRzB;;AA4CA;EACE,WAAA;EACA,cAAA;AAzCF;AA2CE;EACE,cAAA;AAzCJ;AA6CE;EACE,aAAA;EACA,iBAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,iBAAA;AA5CJ;AA+CE;EACE,aAAA;EACA,iBAAA;AA7CJ;AAgDE;EACE,YAAA;AA9CJ;AAiDE;EACE,eAAA;EACA,cC/HgB;ADgFpB;;AAqDA;EACE,uBAAA;AAlDF;;AAqDA;EACE,gBAAA;AAlDF;AAoDE;EACE,aAAA;EACA,qDAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AAlDJ;AAqDE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCzJgB;ADsGpB;AAsDE;EACE,kBAAA;EACA,eAAA;EACA,cC/JgB;AD2GpB;AAuDE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBC5LQ;ED6LR,eAAA;EACA,gBAAA;AArDJ;AAwDE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,cClLgB;AD4HpB;AAyDE;EACE,SAAA;EACA,WAAA;EACA,oBAAA;EACA,wEAAA;AAvDJ;;AA8DA;EACE,UAAA;AA3DF;;AA8DA;EACE,gBAAA;AA3DF;;AA+DA;EACE,mBAAA;EACA,WAAA;AA5DF;AA8DE;;EAEE,UAAA;AA5DJ;;AAgEA;EACE,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AA7DF;AA+DE;EACE,mBAAA;AA7DJ;AAgEE;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,cCnOgB;ADqKpB;AAiEE;EAEE,kBAAA;AAhEJ;AAmEE;EACE,gBAAA;EACA,mBAAA;AAjEJ;AAoEE;EACE,gBAAA;EACA,kBCvQQ;EDwQR,gBAAA;AAlEJ;;AAwEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AArEF;AAuEE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cCnQM;AD8LV;;AAyEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAtEF;AAwEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,kBAAA;AAtEJ;AAyEE;EACE,gBAAA;EACA,cCtRM;AD+MV;AA0EE;EACE,gBAAA;EACA,cC1RgB;ADkNpB;AA2EE;EACE,YAAA;EACA,WAAA;EACA,kBCpTQ;EDqTR,mBC7RU;ED8RV,gBAAA;AAzEJ;AA4EE;EACE,YAAA;EACA,kBC3TQ;ED4TR,mBC3SS;ED4ST,2BAAA;AA1EJ;AA6EE;EACE,eAAA;EACA,eAAA;EACA,cC/SgB;ADoOpB;;AAiFA;EACE,kBAAA;AA9EF;AAgFE;EACE,aAAA;EACA,WAAA;EACA,mBC9UQ;ED+UR,gBAAA;EACA,yBAAA;AA9EJ;AAiFE;EACE,kBAAA;EACA,yBAAA;EACA,4CAniB2B;EAoiB3B,aAAA;EACA,eAAA;EACA,gCAAA;EACA,UAAA;AA/EJ;AAiFI;EACE,qBAAA;AA/EN;AAmFE;EACE,kBAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBCxWQ;EDyWR,mBC7iBI;ED8iBJ,yBAAA;EACA,4CAvjB2B;EAwjB3B,eAAA;EACA,UAAA;EACA,oBAAA;AAjFJ;AAmFI;EACE,aAAA;EACA,cC9Vc;AD6QpB;AAqFE;EACE,gBAAA;EACA,cCrWM;ADkRV;AAsFE;EACE,cCvWY;ADmRhB;;AAwFA;EACE;IACI,oCAAA;EArFJ;AACF","sourcesContent":["@import \"../../../styles/variables\";\n\n$restaurant-muted-surface: hsla(220, 10%, 46%, 0.08);\n$restaurant-muted-foreground: $dt-text-secondary;\n$restaurant-card-shadow: 0 1px 2px rgba(18, 22, 33, 0.06);\n$restaurant-card-shadow-hover: 0 4px 14px rgba(18, 22, 33, 0.1);\n\n.restaurant-analytics-dashboard {\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  max-width: 100%;\n  margin: 0 0 16px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: visible;\n  color: $dt-text;\n  font-family: $font-family;\n\n  &__tabs {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 8px;\n    padding: 8px;\n    margin-bottom: 18px;\n    border-radius: 18px;\n    background: hsla(220, 10%, 46%, 0.08);\n    width: fit-content;\n    max-width: 100%;\n    flex-shrink: 0;\n  }\n\n  &__tab {\n    border: 0;\n    border-radius: 14px;\n    background: transparent;\n    color: hsl(220, 10%, 46%);\n    padding: 14px 20px;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.15;\n    cursor: pointer;\n    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.72);\n      color: $dt-text;\n    }\n  }\n\n  &__tab--active {\n    background: #ffffff;\n    color: #17325c;\n    box-shadow: 0 10px 26px rgba(23, 50, 92, 0.12);\n  }\n\n  &__section {\n    display: flex;\n    flex-direction: column;\n    align-self: stretch;\n    gap: 16px;\n    width: 100%;\n    min-width: 0;\n  }\n\n  &__kpi-row {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 12px;\n\n    @media (max-width: 1180px) {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    @media (max-width: 640px) {\n      grid-template-columns: minmax(0, 1fr);\n    }\n  }\n\n  &__grid {\n    display: grid;\n    gap: 16px;\n\n    &--two {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n\n      @media (max-width: 960px) {\n        grid-template-columns: minmax(0, 1fr);\n      }\n    }\n\n    &--branches {\n      grid-template-columns: repeat(5, minmax(0, 1fr));\n\n      @media (max-width: 1180px) {\n        grid-template-columns: minmax(0, 1fr);\n      }\n    }\n\n    &--menu-detail {\n      grid-template-columns: repeat(3, minmax(0, 1fr));\n\n      @media (max-width: 1180px) {\n        grid-template-columns: minmax(0, 1fr);\n      }\n    }\n  }\n\n  &__card--span-two {\n    grid-column: span 2;\n\n    @media (max-width: 1180px) {\n      grid-column: span 1;\n    }\n  }\n\n  &__card--span-three {\n    grid-column: span 3;\n\n    @media (max-width: 1180px) {\n      grid-column: span 1;\n    }\n  }\n\n  &__card {\n    display: flex;\n    flex-direction: column;\n    background: $white;\n    border: 1px solid $dt-border;\n    border-radius: $radius-md;\n    box-shadow: $restaurant-card-shadow;\n    min-width: 0;\n    height: 100%;\n    // Clips the footer's bottom edge to the card's own rounded corners.\n    overflow: hidden;\n  }\n\n  &__card-head {\n    flex-shrink: 0;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    min-height: 32px;\n    padding: 20px 20px 0;\n  }\n\n  &__card-title-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    min-width: 0;\n  }\n\n  &__card-title {\n    margin: 0;\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.3;\n    color: $dt-text;\n  }\n\n  // Sits on the title baseline rather than the row's stretched box.\n  &__card-title-row .definition-tooltip {\n    display: inline-flex;\n    align-items: center;\n  }\n\n  &__card-body {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    padding: 16px 20px 20px;\n  }\n\n  &__card:has(&__card-footer) &__card-body {\n    padding-bottom: 0;\n  }\n\n  &__card-footer {\n    flex-shrink: 0;\n  }\n\n  &__source-note {\n    margin: 8px 0 24px;\n    text-align: center;\n    font-size: 11px;\n    color: $dt-text-muted;\n  }\n}\n\n\n.restaurant-header-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 10px;\n}\n\n\n.restaurant-filter-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n\n  .ant-select {\n    min-width: 150px;\n  }\n\n  &__reset {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border: 1px solid $dt-border;\n    border-radius: $radius-md;\n    background: $white;\n    color: $dt-text;\n    cursor: pointer;\n    flex-shrink: 0;\n    margin-top: 10px;\n    transition: background 0.15s ease, opacity 0.15s ease;\n\n    &:hover:not(:disabled) {\n      background: $dt-bg-light;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      margin-top: 10px;\n       width: 40px;\n      height: 40px;\n    }\n  }\n}\n\n.restaurant-ai-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n\n.restaurant-kpi-card {\n  position: relative;\n  overflow: hidden;\n  border-radius: $radius-md;\n  min-height: 0;\n  gap: 8px;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset-inline-start: 0;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n  }\n\n  .dashboard-kpi-card__title-row {\n    align-items: center;\n    margin-bottom: 0;\n  }\n\n  .dashboard-kpi-card__title {\n    line-height: 1.4;\n  }\n\n  .definition-tooltip__trigger {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &--primary::before {\n    background: $dt-primary;\n  }\n\n  &--success::before {\n    background: $dt-success;\n  }\n\n  &--warning::before {\n    background: $dt-warning;\n  }\n\n  &--destructive::before {\n    background: $dt-danger;\n  }\n}\n\n// Charts\n\n.restaurant-chart-toggle {\n  display: flex;\n  gap: 2px;\n  padding: 2px;\n  border-radius: $radius-md;\n  background: $dt-bg-light;\n\n  &__btn {\n    border: 0;\n    background: transparent;\n    padding: 4px 10px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 600;\n    color: $restaurant-muted-foreground;\n    cursor: pointer;\n\n    &--active {\n      background: $white;\n      color: $dt-text;\n      box-shadow: $restaurant-card-shadow;\n    }\n  }\n}\n\n.restaurant-chart {\n  width: 100%;\n  flex: 1 1 auto;\n\n  .recharts-surface {\n    direction: ltr;\n  }\n\n  // +24px over the other charts so the legend does not eat into the plot area.\n  &--trend {\n    height: 304px;\n    min-height: 304px;\n  }\n\n  &--donut {\n    height: 260px;\n    min-height: 260px;\n  }\n\n  &--category-bars {\n    height: 260px;\n    min-height: 260px;\n  }\n\n  &--horizontal-bars {\n    height: auto;\n  }\n\n  &__legend-label {\n    font-size: 11px;\n    color: $restaurant-muted-foreground;\n  }\n}\n\n// Heatmap\n\n.restaurant-heatmap-body {\n  padding: 16px 20px 20px;\n}\n\n.restaurant-heatmap {\n  overflow-x: auto;\n\n  &__row {\n    display: grid;\n    grid-template-columns: 56px repeat(8, minmax(0, 1fr));\n    gap: 4px;\n    min-width: 420px;\n    margin-bottom: 4px;\n  }\n\n  &__row-label {\n    display: flex;\n    align-items: center;\n    font-size: 11px;\n    font-weight: 500;\n    color: $restaurant-muted-foreground;\n  }\n\n  &__hour-label {\n    text-align: center;\n    font-size: 10px;\n    color: $restaurant-muted-foreground;\n  }\n\n  &__cell {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 32px;\n    border-radius: $radius-sm;\n    font-size: 10px;\n    font-weight: 500;\n  }\n\n  &__legend {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-top: 12px;\n    font-size: 10px;\n    color: $restaurant-muted-foreground;\n  }\n\n  &__legend-bar {\n    flex: 1;\n    height: 8px;\n    border-radius: 999px;\n    background: linear-gradient(to right, rgba(44, 104, 173, 0.12), $dt-primary);\n  }\n}\n\n// Tables\n\n\n.restaurant-table-body {\n  padding: 0;\n}\n\n.restaurant-table-scroll {\n  overflow-x: auto;\n}\n\n\n.restaurant-wide-table.dashboard-data-table {\n  table-layout: fixed;\n  width: 100%;\n\n  th:first-child,\n  td:first-child {\n    width: 28%;\n  }\n}\n\n.restaurant-retention-table {\n  width: 92%;\n  min-width: 370px;\n  border-collapse: separate;\n  border-spacing: 4px;\n  font-size: 11px;\n  margin: 16px 20px 20px;\n\n  td {\n    border-bottom: none;\n  }\n\n  th {\n    text-align: start;\n    padding: 4px;\n    font-weight: 600;\n    color: $restaurant-muted-foreground;\n  }\n\n  &__month-heading,\n  &__cell {\n    text-align: center;\n  }\n\n  &__cohort {\n    font-weight: 500;\n    white-space: nowrap;\n  }\n\n  &__cell {\n    padding: 8px 4px;\n    border-radius: $radius-sm;\n    font-weight: 600;\n  }\n}\n\n// Abandoned cart\n\n.restaurant-abandoned-cart {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  &__title {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: $dt-text;\n  }\n}\n\n.restaurant-cart-funnel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n\n  &__stage-head {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    font-size: 12px;\n    margin-bottom: 4px;\n  }\n\n  &__stage-name {\n    font-weight: 500;\n    color: $dt-text;\n  }\n\n  &__stage-value {\n    font-weight: 700;\n    color: $restaurant-muted-foreground;\n  }\n\n  &__track {\n    height: 24px;\n    width: 100%;\n    border-radius: $radius-md;\n    background: $dt-bg-light;\n    overflow: hidden;\n  }\n\n  &__fill {\n    height: 100%;\n    border-radius: $radius-md;\n    background: $dt-primary;\n    transition: width 0.2s ease;\n  }\n\n  &__footer {\n    margin: 4px 0 0;\n    font-size: 11px;\n    color: $restaurant-muted-foreground;\n  }\n}\n\n// Branch map\n\n.restaurant-branch-map {\n  position: relative;\n\n  &__canvas {\n    height: 360px;\n    width: 100%;\n    border-radius: $radius-lg;\n    overflow: hidden;\n    border: 1px solid $dt-border;\n  }\n\n  &__pin {\n    border-radius: 50%;\n    border: 2px solid $white;\n    box-shadow: $restaurant-card-shadow-hover;\n    opacity: 0.85;\n    cursor: pointer;\n    transition: transform 0.15s ease;\n    padding: 0;\n\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n\n  &__popup {\n    position: absolute;\n    transform: translate(-50%, -100%);\n    margin-top: -16px;\n    min-width: 160px;\n    padding: 10px 12px;\n    border-radius: $radius-md;\n    background: $white;\n    border: 1px solid $dt-border;\n    box-shadow: $restaurant-card-shadow-hover;\n    font-size: 12px;\n    z-index: 2;\n    pointer-events: none;\n\n    p {\n      margin: 2px 0;\n      color: $dt-text-secondary;\n    }\n  }\n\n  &__popup-name {\n    font-weight: 700;\n    color: $dt-text;\n  }\n\n  &__popup-city {\n    color: $dt-text-muted;\n  }\n}\n\n@media (max-width: 1024px) {\n  .dashboard-section-header__actions {\n      justify-content: flex-end !important;\n  }\n}","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
